export enum FormSearchBlock {
  Root = 'FormSearch',
}

export enum FormSearchElement {
  Controls = 'controls',
  Search = 'search',
}
